import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import WriteToManager from "../../components/pages/WriteToManager/WriteToManager";

const WriteToManagerPage: React.FC = () => {
  return (
    <Layout>
      <WriteToManager />
      <Feedback />
    </Layout>
  );
};

export default WriteToManagerPage;
